export default {
  bulk_messages: (state) => state.bulk_messages,
};
